module.exports = __webpack_public_path__ + "img/manage-vehicle-1-mobile.6943d2e1.gif";